import MailLineIcon from 'remixicon-react/MailLineIcon';
import GithubLineIcon from 'remixicon-react/GithubLineIcon';
import LinkedinFillIcon from 'remixicon-react/LinkedinFillIcon';
import FileList3LineIcon from 'remixicon-react/FileList3LineIcon';
import ArrowUpLineIcon from 'remixicon-react/ArrowUpLineIcon';
import Resume from '../../../assets/Kyle_Moreau_Resume.pdf';
import Reveal from '../../Reveal';
import SectionHeading from '../../SectionHeading';

const contactLinks = [
  {
    href: 'mailto:williamkylemoreau@gmail.com',
    label: 'Email',
    Icon: MailLineIcon,
  },
  {
    href: 'https://www.linkedin.com/in/kyle-moreau/',
    label: 'LinkedIn',
    Icon: LinkedinFillIcon,
  },
  {
    href: 'https://github.com/notkylemoreau98',
    label: 'GitHub',
    Icon: GithubLineIcon,
  },
  {
    href: Resume,
    label: 'Résumé',
    Icon: FileList3LineIcon,
  },
];

const Contact = () => {
  return (
    <section
      id='contact'
      className='relative text-paper bg-ink px-5 py-20 md:px-10 lg:px-20 md:min-h-screen md:flex md:flex-col md:justify-center overflow-hidden'
    >
      <div
        className='pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-accent/25 blur-[130px]'
        aria-hidden='true'
      />

      <div className='relative'>
        <SectionHeading number='04 — Contact' title='Get in Touch' light />

        <Reveal delay={80} className='-mt-8'>
          <p className='text-center text-paper/60 mb-14 max-w-[480px] mx-auto'>
            Open to new opportunities and always happy to talk shop. Reach
            out through any of the channels below.
          </p>
        </Reveal>

        <Reveal delay={160}>
          <div className='flex justify-center gap-4 sm:gap-6'>
            {contactLinks.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={label}
                className='h-14 w-14 md:h-16 md:w-16 flex items-center justify-center rounded-full border border-paper/15 text-paper/70 transition-all duration-300 hover:text-accent hover:border-accent hover:-translate-y-1'
              >
                <Icon size={26} />
              </a>
            ))}
          </div>
        </Reveal>

        <div className='mt-16'>
          <a href='#home' className='block w-[max-content] my-0 mx-auto'>
            <div className='h-10 w-10 flex items-center justify-center rounded-full border border-paper/20 text-paper/70 transition-all duration-300 hover:text-accent hover:border-accent hover:-translate-y-1'>
              <ArrowUpLineIcon size={20} />
            </div>
          </a>

          <p className='mt-10 text-center text-sm text-paper/40'>
            © {new Date().getFullYear()} Kyle Moreau. All Rights Reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
